define(
    'viewmodels/logout',[
        "plugins/router",
        "viewmodels/ViewModel",
        "viewmodels/controller"
    ],
    function (router, ViewModel, shell) {
        var vm = new ViewModel(
        {
            isOverlay : ko.observable(false)
        });

        vm.activate = function (param) {                        
            sessionStorage.setItem("view-library-id", null);
            sessionStorage.setItem("view-list-id", null);
            sessionStorage.removeItem("navto");

            vm.isOverlay(false);
            shell.isBusy(true, "Logging out", 1);

            setTimeout(function () {
                shell.isBusy(false);
                vm.isOverlay(true);

                vm.session.logout()
                .done(function () {
                    if (param && !!param.iscanceltrial && param.iscanceltrial === "1") {
                        console.warn(param.iscanceltrial);
                        shell.isBusy(true, "Please wait", 1);

                        setTimeout(function () {
                            window.location.hash = "#trialcancelled";
                            window.location.reload(false);

                            shell.isBusy(false);
                            vm.isOverlay(false);
                        }, 500);
                    } else {
                        shell.isBusy(true, "Please wait while we redirect you to login page", 1);

                        setTimeout(function () {
                            //router.navigate("#login");

                            // hard-reset 
                            //window.location.assign("#login");
                            //window.location.reload(true);                        

                            //router.navigate("#login");

                            window.location.hash = "#login";
                            window.location.reload(false);

                            shell.isBusy(false);
                            vm.isOverlay(false);
                        }, 500);
                    }
                });                
            }, 1400);
        };
        vm.attached = function () {
        };

        return vm;
    }
);

